/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_GenericInputs */

const cs_api_error_generic = /** @type {(inputs: Api_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Něco se pokazilo. Zkuste to znovu.`)
};

const en_api_error_generic = /** @type {(inputs: Api_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Try again.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Try again." |
*
* @param {Api_Error_GenericInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_generic = /** @type {((inputs?: Api_Error_GenericInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_GenericInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_generic(inputs)
	return cs_api_error_generic(inputs)
});